import React from 'react';
import ModerationProfileGeneralInformations from './components/moderationProfileGeneralInformations';
import ModerationProfileRequesterInformations from './components/moderationProfileRequesterInformations';
import ModerationProfileAttendeeInformations from './components/moderationProfileAttendeeInformations';
import ModerationProfileHistory from './components/moderationProfileHistory';

export const ModerationProfileLeftContainer = ({ attendee, order, organization, flowId, historyDatas, loadingHistoryDatas, syncOrder, syncHistoryDatas, syncAttendee }) => {
    return (
        <div>
            <ModerationProfileGeneralInformations order={order} attendee={attendee} />
            <ModerationProfileRequesterInformations
                order={order}
                organizationId={organization.id}
                orderId={attendee?.order}
                flowId={flowId}
                syncOrder={syncOrder}
                attendee={attendee}
            />
            <ModerationProfileAttendeeInformations attendee={attendee} organizationId={organization.id} attendeeId={attendee.pk} flowId={flowId} syncAttendee={syncAttendee} />
            <ModerationProfileHistory
                organizationId={organization.pk}
                flowId={flowId}
                attendee={attendee}
                historyDatas={historyDatas}
                syncHistory={syncHistoryDatas}
                loadingHistoryDatas={loadingHistoryDatas}
            />
        </div>
    );
};
